const NAMESPACE = "ePaymentPage";

const KEYS = {
    paymentsDisabledMessage: "paymentsDisabledMessage",
    isNotConfiguredForPaymentMessage: "isNotConfiguredForPaymentMessage",
    paymentInformationLoadingMessage: "paymentInformationLoadingMessage",
    paymentConfirmationPendingHeader: "paymentConfirmationPendingHeader",
    abandonPaymentButtonLabel: "abandonPaymentButtonLabel",
    previousPaymentsTableHeader: "previousPaymentsTableHeader",
    previousPaymentsDateColumnHeader: "previousPaymentsDateColumnHeader",
    previousPaymentsAmountColumnHeader: "previousPaymentsAmountColumnHeader",
    previousPaymentsPayerEmailColumnHeader: "previousPaymentsPayerEmailColumnHeader",
    previousPaymentsPayerNameColumnHeader: "previousPaymentsPayerNameColumnHeader",
    previousPaymentsReceiptNumberColumnHeader: "previousPaymentsReceiptNumberColumnHeader",
    ePaymentPageHeader: "ePaymentPageHeader",
    unsubmittedPaymentsMessage: "unsubmittedPaymentsMessage",
    unsubmittedPaymentsTableHeader: "unsubmittedPaymentsTableHeader",
    missingFieldsMessage: "missingFieldsMessage",
    formValidationErrorsMessage: "formValidationErrorsMessage",
    chargeAmountErrorMessage: "chargeAmountErrorMessage",
    errorLabel: "errorLabel",
    amountErrorLabel: "amountErrorLabel",
    projectNumberLabel: "projectNumberLabel",
    amountToPayLabel: "amountToPayLabel",
    billingEmailLabel: "billingEmailLabel",
    confirmBillingEmailLabel: "confirmBillingEmailLabel",
    confirmBillingEmailErrorMessage: "confirmBillingEmailErrorMessage",
    ePaymentTypeLabel: "ePaymentTypeLabel",
    ePaymentTypeNotSelectedText: "ePaymentTypeNotSelectedText",
    ePayButtonLabel: "ePayButtonLabel",
    outsidePayButtonLabel: "outsidePayButtonLabel",
    paymentNotRequiredMessage: "paymentNotRequiredMessage",
    simultaneousPaymentsErrorDialogTitle: "simultaneousPaymentsErrorDialogTitle",
    simultaneousPaymentsErrorMessage: "simultaneousPaymentsErrorMessage",
    stripeLoadingErrorDialogTitle: "stripeLoadingErrorDialogTitle",
    stripeLoadingErrorMessage: "stripeLoadingErrorMessage",
    defaultProcessingMessage: "defaultProcessingMessage",
    outsidePaymentSuccessfulDialogTitle: "outsidePaymentSuccessfulDialogTitle",
    ePaymentSuccessfulDialogTitle: "ePaymentSuccessfulDialogTitle",
    successfulPaymentDialogButtonLabel: "successfulPaymentDialogButtonLabel",
    cancelUnsuccessfulDialogTitle: "cancelUnsuccessfulDialogTitle",
    cancelUnsuccessfulErrorMessage: "cancelUnsuccessfulErrorMessage",
    cancelUnsuccessfulDialogButtonLabel: "cancelUnsuccessfulDialogButtonLabel",
    confirmCancelPaymentDialogTitle: "confirmCancelPaymentDialogTitle",
    yesButtonLabel: "yesButtonLabel",
    noButtonLabel: "noButtonLabel"
};

const MESSAGES = {
    [KEYS.paymentsDisabledMessage]: {
        value: "Payments are disabled: This is a preview project.",
        comment: "Message displayed when payments are disabled for a preview project"
    },
    [KEYS.isNotConfiguredForPaymentMessage]: {
        value: "This program is not configured to accept payments. If you have questions, please contact your program administrator.",
        comment: "Message displayed when the program is not correctly configured to accept payments"
    },
    [KEYS.paymentInformationLoadingMessage]: {
        value: "Loading Payment Information...",
        comment: "Message displayed on spinner when loading payment information"
    },
    [KEYS.paymentConfirmationPendingHeader]: {
        value: "Payment Confirmation Pending",
        comment: "Header displayed when payment confirmation is pending"
    },
    [KEYS.abandonPaymentButtonLabel]: {
        value: "Abandon Pending Payment and Unlock Project",
        comment: "Label for button used to abandon a pending payment and unlock the project"
    },
    [KEYS.previousPaymentsTableHeader]: {
        value: "Previous Payments",
        comment: "Header for the table showing previous payments"
    },
    [KEYS.previousPaymentsDateColumnHeader]: {
        value: "Date",
        comment: "Header for the Date column in the Previous Payments table"
    },
    [KEYS.previousPaymentsAmountColumnHeader]: {
        value: "Amount",
        comment: "Header for the Amount column in the Previous Payments table"
    },
    [KEYS.previousPaymentsPayerEmailColumnHeader]: {
        value: "Email",
        comment: "Header for the Payer Email column in the Previous Payments table"
    },
    [KEYS.previousPaymentsPayerNameColumnHeader]: {
        value: "Payer",
        comment: "Header for the Payer Name column in the Previous Payments table"
    },
    [KEYS.previousPaymentsReceiptNumberColumnHeader]: {
        value: "Payment ID",
        comment: "Header for the Receipt Number column in the Previous ePayments table"
    },
    [KEYS.ePaymentPageHeader]: {
        value: "ePayment",
        comment: "Header for the ePayment page"
    },
    [KEYS.unsubmittedPaymentsMessage]: {
        value: "There are processed payments for this form, but it is not yet submitted. Please submit the form.",
        comment: "Message displayed when the form has processed payments, but the form has not been submitted"
    },
    [KEYS.unsubmittedPaymentsTableHeader]: {
        value: "Unsubmitted ePayments",
        comment: "Header for unsubmitted payments table"
    },
    [KEYS.missingFieldsMessage]: {
        value: "There are missing fields. Please see message below.",
        comment: "Message displayed when there are missing fields"
    },
    [KEYS.formValidationErrorsMessage]: {
        value: "There are form validation errors. Please see message below.",
        comment: "Message displayed when there are automation failures"
    },
    [KEYS.chargeAmountErrorMessage]: {
        value: "A configuration error was encountered while calculating the payment amount. Please contact your program administrator for assistance.",
        comment: "Message displayed when an error occurred calculating the payment ammount"
    },
    [KEYS.errorLabel]: {
        value: "Error:",
        comment: "Label for the charge amount validation error text"
    },
    [KEYS.amountErrorLabel]: {
        value: "Amount:",
        comment: "Label for the charge amount"
    },
    [KEYS.projectNumberLabel]: {
        value: "A project number has been generated:",
        comment: "Label for the project number"
    },
    [KEYS.amountToPayLabel]: {
        value: "Amount to pay:",
        comment: "Generic label for the amount display"
    },
    [KEYS.billingEmailLabel]: {
        value: "Billing Email Address",
        comment: "Label for the Billing Email Address input"
    },
    [KEYS.confirmBillingEmailLabel]: {
        value: "Confirm Billing Email Address",
        comment: "Label for the Billing Email Address confirmation input"
    },
    [KEYS.confirmBillingEmailErrorMessage]: {
        value: "Emails must match",
        comment: "Message displayed when the billing email inputs do not match"
    },
    [KEYS.ePaymentTypeLabel]: {
        value: "Please select your ePayment method:",
        comment: "Label for the ePayment Type selector"
    },
    [KEYS.ePaymentTypeNotSelectedText]: {
        value: "None selected...",
        comment: "Text for the option when no ePayment Type has been selected"
    },
    [KEYS.ePayButtonLabel]: {
        value: "ePay and Submit",
        comment: "Label for the button to ePay and submit the form"
    },
    [KEYS.outsidePayButtonLabel]: {
        value: "Pay Outside of PowerClerk",
        comment: "Label for the button to pay outside of PowerClerk"
    },
    [KEYS.paymentNotRequiredMessage]: {
        value: "Payment is not required. Press the Submit button to continue.",
        comment: "Message displayed when no payment is required"
    },
    [KEYS.simultaneousPaymentsErrorDialogTitle]: {
        value: "Simultaneous Payment Attempts",
        comment: "Title of error dialog displayed when simultaneous payments are detected"
    },
    [KEYS.simultaneousPaymentsErrorMessage]: {
        value: "The payment process for this project might have been started in a different tab. The page will now reload.",
        comment: "Error message displayed when simultaneous payments are detected"
    },
    [KEYS.stripeLoadingErrorDialogTitle]: {
        value: "Stripe Loading Error",
        comment: "Title of error dialog displayed when a Stripe loading error occurs"
    },
    [KEYS.stripeLoadingErrorMessage]: {
        value: "There was an error loading Stripe. No payment attempt has been made. Please try again. The page will now reload.",
        comment: "Error message displayed when a Stripe loading error occurs"
    },
    [KEYS.defaultProcessingMessage]: {
        value: "Processing...",
        comment: "Default message shown with a spinner when an ePayment is processing or being cancelled"
    },
    [KEYS.outsidePaymentSuccessfulDialogTitle]: {
        value: "Your information has been submitted.",
        comment: "Title of dialog displayed after a successful payment is made outside of PowerClerk"
    },
    [KEYS.ePaymentSuccessfulDialogTitle]: {
        value: "Information submitted. Payment processing.",
        comment: "Title of dialog displayed after a successful ePayment is made"
    },
    [KEYS.successfulPaymentDialogButtonLabel]: {
        value: "Continue",
        comment: "Label for the button in the dialog displayed after a successful payment"
    },
    [KEYS.cancelUnsuccessfulDialogTitle]: {
        value: "Cancel Was Unsuccessful",
        comment: "Title of dialog displayed when an attempt to cancel an ePayment is unsuccessful"
    },
    [KEYS.cancelUnsuccessfulErrorMessage]: {
        value:
            "A payment was already in process when you attempted to cancel. " +
            "Your project will be locked until the status of that payment is resolved. " +
            "Please contact your program administrator if you have any questions about the status of your payment.",
        comment: "Error message displayed when an attempt to cancel an ePayment is unsuccessful"
    },
    [KEYS.cancelUnsuccessfulDialogButtonLabel]: {
        value: "Close",
        comment: "Label for the button in the dialog displayed when an attempt to cancel an ePayment is unsuccessful"
    },
    [KEYS.confirmCancelPaymentDialogTitle]: {
        value: "Are you sure?",
        comment: "Title for dialog displayed when an attempt is made to cancel a payment that is pending"
    },
    [KEYS.yesButtonLabel]: {
        value: "Yes",
        comment: "Text for yes button"
    },
    [KEYS.noButtonLabel]: {
        value: "No",
        comment: "Text for no button"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
